module.exports = __webpack_public_path__ + "img/edit.8967c22f.svg";